import {publishOpenCopilotChat} from '@github-ui/copilot-chat-events'
import {CopilotChatIntents, type FileDiffReference} from '@github-ui/copilot-chat-types'
import {getExplainDiffPrompt} from '@github-ui/copilot-chat-helpers/prompts'
import {sendEvent} from '@github-ui/hydro-analytics'
import {ActionList} from '@primer/react'

export interface DiffLinesExplainMenuItemProps {
  fileDiffReference: FileDiffReference
  eventContext?: Parameters<typeof sendEvent>[1]
  afterSelect?: () => void
}

export const DiffLinesExplainMenuItem: React.FC<DiffLinesExplainMenuItemProps> = ({
  fileDiffReference,
  eventContext,
  afterSelect,
}) => {
  const handleExplain = () => {
    sendEvent('copilot.file-diff.explain', {
      target: 'file-diff',
      mode: 'assistive',
      ...eventContext,
    })
    publishOpenCopilotChat({
      content: getExplainDiffPrompt(),
      intent: CopilotChatIntents.conversation,
      references: [fileDiffReference],
      skipImplicitReferences: true,
    })
    afterSelect?.()
  }

  return <ActionList.Item onSelect={handleExplain}>Explain</ActionList.Item>
}
